import { render, staticRenderFns } from "./ManufacturingMaterialList.vue?vue&type=template&id=4c039b0f&scoped=true&"
import script from "./ManufacturingMaterialList.vue?vue&type=script&lang=js&"
export * from "./ManufacturingMaterialList.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturingMaterialList.vue?vue&type=style&index=0&id=4c039b0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c039b0f",
  null
  
)

export default component.exports